import { parse } from 'cookie'

import { formatLaunch, formatModule } from '../launchExportFormatutils'
import { isOauthNeeded, openOauthWindow } from '../oauthUtils'

import { setCookies } from '~lib/helpers'
import {
  LaunchContentType,
  LaunchModuleContentType,
} from '~modules/launches/containers/DocumentsIntegrationModal/utils'

export const googleOauth2 = async (originHref: string, originUrl: string) => {
  if (await isOauthNeeded('GOOGLE')) {
    const encodedRedirUri = encodeURIComponent(`${originUrl}/api/googleCallback`)
    const clientID = process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID
    const state = Buffer.from(`${originUrl} ${originHref}`).toString('base64')
    const authUrl = [
      'https://accounts.google.com/o/oauth2/v2/auth?',
      'scope=https%3A//www.googleapis.com/auth/drive&',
      'include_granted_scopes=true&',
      'response_type=code&',
      `state=${state}&`,
      `redirect_uri=${encodedRedirUri}&`,
      `client_id=${clientID}`,
    ].join('')
    const payload: any = await openOauthWindow(authUrl)
    const { GOOGLE_ACCESS_TOKEN } = payload
    setCookies({ GOOGLE_ACCESS_TOKEN })
  }
}

export const getAccessToken = () => {
  const accessToken = parse(document.cookie).GOOGLE_ACCESS_TOKEN
  return accessToken
}

export const formatLaunchContentGoogle = (fileName: string, content: LaunchModuleContentType | LaunchContentType) => {
  let html = ''
  if (fileName.search('Ignition') > -1) {
    html = formatLaunch(content as LaunchContentType, 'GOOGLE')
  } else {
    html = formatModule(fileName, content as LaunchModuleContentType, 'GOOGLE')
  }

  return html
}
